import { memo, useMemo } from 'react';
import { AvatarStack } from '@cyphex/ui';
import type { UserRef } from '@cyphex/types';

interface ReadReceiptRowProps {
  readers: readonly UserRef[];
}

const MAX_FACES = 5;

/** Facepile under the last message every other member has read. */
export const ReadReceiptRow = memo(function ReadReceiptRow({ readers }: ReadReceiptRowProps) {
  const people = useMemo(
    () =>
      readers.map((user) => ({
        id: user.id,
        name: user.displayName,
        ...(user.avatarUrl ? { src: user.avatarUrl } : {}),
      })),
    [readers],
  );

  if (people.length === 0) return null;

  return (
    <div className="flex items-center justify-end gap-1.5 px-4 pb-1 pt-0.5">
      <span className="text-sm text-muted-foreground">Read by</span>
      <AvatarStack
        people={people}
        max={MAX_FACES}
        size="xs"
        overlap="none"
        showOverflow
        label={`Read by ${people.map((person) => person.name).join(', ')}`}
      />
    </div>
  );
});
